import type { VideoPanel } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSCTA } from '@swf/cms';

import styles from './CMSVideoPanel.scss';

const CMSVideoPanel: React.FC<VideoPanel> = ({ mp4, webm, cta, poster }) => (
  <div className={styles.fullwidth}>
    <video poster={poster?.url} autoPlay loop muted className={styles.fullwidthVideo}>
      <source type="video/mp4" src={mp4?.url} />
      <source type="video/webm" src={webm?.url} />
    </video>
    <CMSCTA {...cta} className={styles.fullwidthCta} />
  </div>
);

export default CMSVideoPanel;
